import React from "react";

function TextInput({
  id,
  placeholder,
  value,
  isError = false,
  errorText,
  disabled = false,
  onChange,
  className,
  type = "text",
}) {
  return (
    <div style={{ display: "block" }}>
      <input
        disabled={disabled}
        value={value}
        id={id}
        type={type}
        className={isError ? className + " error-text" : className}
        placeholder={placeholder}
        onChange={onChange}
      ></input>
      {isError ? <h6 className={" error-text"}>{errorText}</h6> : null}
    </div>
  );
}

export default TextInput;
